import gql from 'graphql-tag';

export const QUERY_GET_SAP = gql`
  query getDiscovers($personId: ID!) {
    getDiscovers(personId: $personId) {
      id
      data
    }
  }
`;
